import { createAction, props } from '@ngrx/store';

export enum UiPreferencesActionTypes {
    LOAD_UI_PREFERENCES = '[UI PREFERENCES] Load',
    SET_UI_PREFERENCES = '[UI PREFERENCES] Set',
    SAVE_UI_PREFERENCES = '[UI PREFERENCES] Save',
    SAVE_UI_PREFERENCES_SUCCESS = '[UI PREFERENCES] Save Success',
    DELETE_UI_PREFERENCES = '[UI PREFERENCES] Delete',
    DELETE_UI_PREFERENCES_SUCCESS = '[UI PREFERENCES] Delete Success',
    SET_UI_PREFERENCES_LOADING = '[UI PREFERENCES] Set Loading',
    SET_UI_PREFERENCES_ERROR = '[UI PREFERENCES] Set Error',
}

/** Trigger a GET /idm/v1/ui-preferences/user call */
export const LoadUiPreferences = createAction(UiPreferencesActionTypes.LOAD_UI_PREFERENCES);

/** Store the fetched preferences in state */
export const SetUiPreferences = createAction(
    UiPreferencesActionTypes.SET_UI_PREFERENCES,
    props<{ preferences: Record<string, any> | null }>()
);

/** Trigger a POST /idm/v1/ui-preferences/user call with a full preferences object */
export const SaveUiPreferences = createAction(
    UiPreferencesActionTypes.SAVE_UI_PREFERENCES,
    props<{ preferences: Record<string, any>; successMessage?: string }>()
);

/** Dispatched after a successful POST */
export const SaveUiPreferencesSuccess = createAction(
    UiPreferencesActionTypes.SAVE_UI_PREFERENCES_SUCCESS,
    props<{ preferences: Record<string, any>; successMessage?: string }>()
);

/** Trigger a DELETE /idm/v1/ui-preferences/user call */
export const DeleteUiPreferences = createAction(UiPreferencesActionTypes.DELETE_UI_PREFERENCES);

/** Dispatched after a successful DELETE */
export const DeleteUiPreferencesSuccess = createAction(UiPreferencesActionTypes.DELETE_UI_PREFERENCES_SUCCESS);

export const SetUiPreferencesLoading = createAction(
    UiPreferencesActionTypes.SET_UI_PREFERENCES_LOADING,
    props<{ loading: boolean }>()
);

export const SetUiPreferencesError = createAction(
    UiPreferencesActionTypes.SET_UI_PREFERENCES_ERROR,
    props<{ error: string | null }>()
);
